import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import axios from 'axios'
import store from '@/store'


Vue.config.productionTip = false

Vue.prototype.$axios = axios

new Vue({
  router,
  vuetify,
  render: h => h(App),
  store
}).$mount('#app')
